import { AppSourceEnum } from 'pu-core-library';
import { UrlConfig } from '@shared/config/url.config';

export class PicklistConfig {

    private static picklists: string = UrlConfig.urlAdmin + 'picklists';

    private static picklistsDetailValues: string = this.picklists + '/all-detail-values';

    public static get picklistsBySource(): string {
        return `${this.picklists}?source-code=${AppSourceEnum.POF}`;
    }

    public static get picklistsDetailValuesBySource(): string {
        return `${this.picklistsDetailValues}?source-code=${AppSourceEnum.POF}`;
    }
}
